import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Copy, Optional } from '@honda-canada/design-system-react';
import themeStyles from '../ConfigureBapStyles';
import { EqualHeightElement } from '../../../utils/components/EqualHeight';
import { useAppSelector } from '../../../core/utils';
import { selectPrimaryCalculatorIsPaymentMethodCash } from '../../../core/reducers/financialCalculators';
const PriceContainer = themeStyles.apply(Box, 'PriceContainer');
const PaymentFrequency = themeStyles.apply(Copy, 'PaymentFrequency');
const AccessoryCardPricing = ({ priceText, paymentText }) => {
    const currentPaymentMethodCash = useAppSelector(selectPrimaryCalculatorIsPaymentMethodCash);
    return (_jsx(EqualHeightElement, { name: "AccessoryPriceContainer", placeholder: !paymentText, children: _jsxs(PriceContainer, { children: [_jsx(Copy, { size: "pricingSmall", pr: "xs", "data-testid": "cy-bap-accessory-price", children: priceText }), _jsx(Optional, { when: !currentPaymentMethodCash, children: _jsx(PaymentFrequency, { size: "frequency", "data-testid": "cy-bap-accessory-payment-frequency", children: paymentText }) })] }) }, priceText));
};
export default AccessoryCardPricing;
